"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coin = void 0;
var react_1 = __importDefault(require("react"));
var Coin = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M6 1c3.314 0 6 1.51 6 3.375v2.25C12 8.489 9.314 10 6 10 2.745 10 .096 8.543.003 6.725L0 6.625v-2.25C0 2.511 2.686 1 6 1Zm0 6.75c-2.03 0-3.824-.566-4.91-1.434v.309c0 1.059 2.119 2.25 4.91 2.25 2.733 0 4.82-1.142 4.906-2.184l.003-.066v-.31C9.825 7.184 8.03 7.75 6 7.75Zm0-5.625c-2.791 0-4.91 1.191-4.91 2.25S3.21 6.625 6 6.625s4.91-1.191 4.91-2.25S8.79 2.125 6 2.125Z", fill: "currentColor" }))); };
exports.Coin = Coin;
